import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import LdoTransp from '../../components/leis/listar/ldo';


function TranspScreen () {
    return (
        <Fragment>
            <Head titulo="Leis de Diretrizes Orçamentárias do Município de Macuco"/>
            <Header />
            <Container>
                <LdoTransp />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default TranspScreen;